/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApplicationView } from '../models/application-view';
import { ApplyCommand } from '../models/apply-command';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apply
   */
  static readonly ApplyPath = '/api/Application/apply';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apply$Response(params?: {
    context?: HttpContext
    body?: ApplyCommand
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.ApplyPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apply(params?: {
    context?: HttpContext
    body?: ApplyCommand
  }
): Observable<ApplicationView> {

    return this.apply$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation getApplication
   */
  static readonly GetApplicationPath = '/api/Application/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApplication()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplication$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.GetApplicationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApplication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplication(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.getApplication$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation getApplicationByListing
   */
  static readonly GetApplicationByListingPath = '/api/Application/listing/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApplicationByListing()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationByListing$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ApplicationView>>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.GetApplicationByListingPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ApplicationView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApplicationByListing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationByListing(params: {
    id: string;
    context?: HttpContext
  }
): Observable<Array<ApplicationView>> {

    return this.getApplicationByListing$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ApplicationView>>) => r.body as Array<ApplicationView>)
    );
  }

  /**
   * Path part for operation getApplications
   */
  static readonly GetApplicationsPath = '/api/Application/GetApplications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApplications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplications$Response(params?: {
    activeOnly?: boolean;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ApplicationView>>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.GetApplicationsPath, 'get');
    if (params) {
      rb.query('activeOnly', params.activeOnly, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ApplicationView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApplications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplications(params?: {
    activeOnly?: boolean;
    context?: HttpContext
  }
): Observable<Array<ApplicationView>> {

    return this.getApplications$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ApplicationView>>) => r.body as Array<ApplicationView>)
    );
  }

  /**
   * Path part for operation withdraw
   */
  static readonly WithdrawPath = '/api/Application/Withdraw/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `withdraw()` instead.
   *
   * This method doesn't expect any request body.
   */
  withdraw$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.WithdrawPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `withdraw$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  withdraw(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.withdraw$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation shortList
   */
  static readonly ShortListPath = '/api/Application/ShortList/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortList()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortList$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.ShortListPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `shortList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortList(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.shortList$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation revert
   */
  static readonly RevertPath = '/api/Application/Revert/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revert()` instead.
   *
   * This method doesn't expect any request body.
   */
  revert$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.RevertPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revert$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revert(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.revert$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation moveIn
   */
  static readonly MoveInPath = '/api/Application/MoveIn/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveIn()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveIn$Response(params: {
    id: string;
    context?: HttpContext
    body?: boolean
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.MoveInPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `moveIn$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveIn(params: {
    id: string;
    context?: HttpContext
    body?: boolean
  }
): Observable<ApplicationView> {

    return this.moveIn$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation confirmMoveIn
   */
  static readonly ConfirmMoveInPath = '/api/Application/ConfirmMoveIn/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmMoveIn()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmMoveIn$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.ConfirmMoveInPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirmMoveIn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmMoveIn(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.confirmMoveIn$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation decline
   */
  static readonly DeclinePath = '/api/Application/Decline/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `decline()` instead.
   *
   * This method doesn't expect any request body.
   */
  decline$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.DeclinePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `decline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  decline(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.decline$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation approve
   */
  static readonly ApprovePath = '/api/Application/Approve/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approve()` instead.
   *
   * This method doesn't expect any request body.
   */
  approve$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApplicationView>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.ApprovePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  approve(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ApplicationView> {

    return this.approve$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationView>) => r.body as ApplicationView)
    );
  }

  /**
   * Path part for operation canApply
   */
  static readonly CanApplyPath = '/api/Application/CanApply/{listingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canApply()` instead.
   *
   * This method doesn't expect any request body.
   */
  canApply$Response(params: {
    listingId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationService.CanApplyPath, 'get');
    if (params) {
      rb.path('listingId', params.listingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canApply$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canApply(params: {
    listingId: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.canApply$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
